import { QueryKey } from '@tanstack/react-query';
import { useCustomToast } from '../../../components';
import apiClient from '../../../services/apiClient';
import { TransformFilters } from '../../../utils';
import { GoodsFilter, GoodsResponse } from '../../WarehouseView/types';
const { showToast } = useCustomToast();

export const RequesedItemsAPI = {
fetchMovements: async ({
  queryKey,
}: {
  queryKey: QueryKey;
}): Promise<GoodsResponse> => {
  const [, filters] = queryKey as [string, GoodsFilter?];
  const transformedFilters = TransformFilters(filters);
  const response = await apiClient.get('/api/petition/good/items', {
    params: {
      ...transformedFilters,
      paginate: true,
      page: filters?.page,
    },
  });
  return response.data 
},
fetchGoodPetition: async (id: string) => {
  const { data } = await apiClient.get(`/api/petition/good/${id}`);
  return data;
},
evaluateConceptPetitionItems: async (evaluationId: string, payload: any) => {
  try {
    const { data } = await apiClient.post(
      `/api/petition/concept/evalItems/${evaluationId}`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al evaluar los ítems.';
    showToast('error', message);
    console.error('Error en evaluateConceptPetitionItems:', error);
    throw error;
  }
},

downloadConceptDocuments: async (id: string) => {
 try {
      const response = await apiClient.get<Blob>(
        `/api/petition/transfer/documents/${id}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `traslados_exportados.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error: any) {
      throw error;
    }
},
fetchParameters: async (keys: string[], filters?: Record<string, string>) => {
  try {
    const queryParams = keys.map((key) => `keys[]=${encodeURIComponent(key)}`).join('&');
    let filterParams = '';
    if (filters) {
      filterParams = Object.entries(filters)
        .map(([key, value]) => `filter[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`)
        .join('&');
    }
    const queryString = `${queryParams}${filterParams ? '&' + filterParams : ''}`;
    const { data } = await apiClient.get(`api/utils/select-tables?${queryString}`);
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al obtener parámetros.';
    showToast('error', message);
    console.error('Error en fetchParameters:', error);
    return null;
  }
},

fetchTransferAdditions: async (evaluationId: string) => {
  try {
    const { data } = await apiClient.get(`/api/asset/related/${evaluationId}`);
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al obtener adiciones de la transferencia.';
    showToast('error', message);
    console.error('Error en fetchTransferAdditions:', error);
    throw error;
  }
},

updateTransferStatus: async (
  transferId: number | string,
  payload: {
    observations: string;
    items: { id: string; status_id: string; observations: string }[];
  }
) => {
  try {
    const { data } = await apiClient.put(
      `/api/petition/transfer/manageItems`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al actualizar estado de los ítems.';
    showToast('error', message);
    console.error('Error en updateTransferStatus:', error);
    throw error;
  }
},

updateEvaluationItems: async (evaluationId: string, payload: any) => {
  try {
    const { data } = await apiClient.put(
      `/api/petition/transfer/${evaluationId}`,
      payload
    );
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message || 'Error al actualizar la evaluación.';
    showToast('error', message);
    console.error('Error en updateEvaluationItems:', error);
    throw error;
  }
},
};
